import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/components/ui/button";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div
      data-testid="not-found-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 p-6 text-center"
    >
      <h1 className="text-3xl font-semibold">{t("errors.notFoundTitle")}</h1>
      <p className="text-muted-foreground">{t("errors.notFoundBody")}</p>
      <Button asChild>
        <Link to="/dashboard" data-testid="navigate-to-dashboard">
          {t("errors.backHome")}
        </Link>
      </Button>
    </div>
  );
}
